export const cursorDefaultStyles = {
    "& .RaDatagrid-row": { cursor: "default" }
};
